import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions } from "../../../../../../../_helpers/Helpers";
import * as actions from "../../../../_redux/student-book-report/StudentBookReportAction";
import { useStandardReportUIContext } from "../StandardReportUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, date, dateEnd, sectionId, studentId, teacherId, studentNumber, bookName, pageNumber } = values;
  studentNumber = studentNumber === "" ? null : studentNumber;
  pageNumber = pageNumber === "" ? null : pageNumber;
  const newQueryParams = { ...queryParams };
  const filter = { date, dateEnd, sectionId, studentId, teacherId, studentNumber, bookName, pageNumber };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function StandardReportFilter() {
  // Standard Report UI Context
  const standardReportUIContext = useStandardReportUIContext();
  const standardReportUIProps = useMemo(() => {
    return {
      term: standardReportUIContext.term,
      date: standardReportUIContext.date,
      dateEnd: standardReportUIContext.dateEnd,
      sectionId: standardReportUIContext.sectionId,
      studentId: standardReportUIContext.studentId,
      queryParams: standardReportUIContext.queryParams,
      setQueryParams: standardReportUIContext.setQueryParams
    };
  }, [standardReportUIContext]);

  const dispatch = useDispatch();
  const { teachers } = useSelector(
    (state) => ({
      teachers: state.studentBookReport.teachers
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getTeachers(standardReportUIProps.term));
  }, [standardReportUIProps.term, dispatch]);

  useEffect(() => {
    applyFilter({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [standardReportUIProps.term, standardReportUIProps.date, standardReportUIProps.dateEnd, standardReportUIProps.sectionId, standardReportUIProps.studentId]);
    
  const applyFilter = (values) => {
    values.term = standardReportUIProps.term;
    values.date = standardReportUIProps.date;
    values.dateEnd = standardReportUIProps.dateEnd;
    values.sectionId = standardReportUIProps.sectionId;
    values.studentId = standardReportUIProps.studentId;
    const newQueryParams = prepareFilter(standardReportUIProps.queryParams, values);
    if (!isEqual(newQueryParams, standardReportUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      standardReportUIProps.setQueryParams(newQueryParams);
    }
  };

  const teacherOptions = FilterOptions.concat(teachers);
  
  return (
    <Formik
      initialValues={{
        studentNumber: "",
        bookName: "",
        pageNumber: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <CustomSelect 
                options={teacherOptions}
                value={values.teacherId}
                placeholder="Öğretmen"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("teacherId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğretmen</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="studentNumber"
                min={1}
                placeholder="Öğrenci Numarası"
                onBlur={handleBlur}
                value={values.studentNumber}
                onChange={(e) => {
                  setFieldValue("studentNumber", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Numarası</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="bookName"
                placeholder="Kitap Adı"
                onBlur={handleBlur}
                value={values.bookName}
                onChange={(e) => {
                  setFieldValue("bookName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kitap Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="pageNumber"
                min={1}
                placeholder="Sayfa Sayısı"
                onBlur={handleBlur}
                value={values.pageNumber}
                onChange={(e) => {
                  setFieldValue("pageNumber", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sayfa Sayısı</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}